// Landing reel slides — Nike hero + 4 major ad films.
// • `video`     → MP4 URL (autoplays muted+looped). Used by the hero Nike slide.
// • `youtubeId` → embedded muted YouTube playback for the ad showcase.
// • `start`     → seconds to start at, so we skip intros and land mid-ad
//                 (the "money shot" / hero VFX moment).
// • `image`     → high-res YT thumbnail. Shows instantly while iframe spins up,
//                 stays visible for ~1.2s before iframe fades in over it.
// • `duration`  → ms the slide is held (auto-advance).
// Hero slide durations are short on purpose — fast, kinetic, "showreel" pacing.
// Per-slide `start` values are picked from varied mid-sections so successive
// slides feel like distinct cuts of the spot, not the same opening title card.
// MP4 hero slide gets a slightly longer hold so the Nike spot reads.
export const PROJECTS = [
    {
        id: "nike",
        title: "Nike",
        subtitle: "Second Skin",
        category: "Commercial",
        year: "2025",
        client: "Nike",
        image:
            "https://static.prod-images.emergentagent.com/jobs/ed6c79c9-0545-4c0e-b197-76f179257e91/images/44a4d8ed9cd53c5822f28aa340b1304697ad64c37fb551b7fe5527d0ecc33163.png",
        video:
            "https://customer-assets.emergentagent.com/job_post-production-mad/artifacts/ep7i4hga_hf_20260424_203434_dfe0f358-d156-4a04-9c2d-5481998ab71b.mp4",
        duration: 7000,
        hasAudio: true
    },
    {
        id: "bgmi-royal-enfield",
        title: "BGMI × Royal Enfield",
        subtitle: "Cinematic brand crossover",
        category: "Brand Film",
        year: "2025",
        client: "BGMI × Royal Enfield",
        youtubeId: "5I86-Av-KoI",
        start: 32,
        image: "https://i.ytimg.com/vi/5I86-Av-KoI/maxresdefault.jpg",
        externalUrl: "https://youtu.be/5I86-Av-KoI",
        duration: 5200
    },
    {
        id: "crocs-rashmika",
        title: "Crocs",
        subtitle: "Rashmika — fashion film",
        category: "Commercial",
        year: "2025",
        client: "Crocs",
        youtubeId: "SS6nqU6IioM",
        start: 18,
        image: "https://i.ytimg.com/vi/SS6nqU6IioM/maxresdefault.jpg",
        externalUrl: "https://youtu.be/SS6nqU6IioM",
        duration: 4800
    },
    {
        id: "cred-tr-nation",
        title: "CRED",
        subtitle: "TR Nation — larger than life",
        category: "Commercial",
        year: "2025",
        client: "CRED",
        youtubeId: "SQtZo4SvBzw",
        start: 72,
        image: "https://i.ytimg.com/vi/SQtZo4SvBzw/maxresdefault.jpg",
        externalUrl: "https://youtu.be/SQtZo4SvBzw",
        duration: 5400
    },
    {
        id: "himalaya-baby-care",
        title: "Himalaya",
        subtitle: "Baby Care — quietly cinematic",
        category: "Brand Film",
        year: "2025",
        client: "Himalaya",
        youtubeId: "XjFUpYPVBl8",
        start: 22,
        image: "https://i.ytimg.com/vi/XjFUpYPVBl8/maxresdefault.jpg",
        externalUrl: "https://youtu.be/XjFUpYPVBl8",
        duration: 4600
    },
    {
        id: "bgmi-hipster",
        title: "BGMI Hipster",
        subtitle: "Street-culture gaming cutdown",
        category: "Brand Film",
        year: "2025",
        client: "BGMI",
        youtubeId: "2bDL4m6x7KU",
        start: 14,
        image: "https://i.ytimg.com/vi/2bDL4m6x7KU/maxresdefault.jpg",
        externalUrl: "https://youtu.be/2bDL4m6x7KU",
        duration: 5000
    },
    {
        id: "bgmi-helmet",
        title: "BGMI Helmet",
        subtitle: "Parody helmet spot",
        category: "Brand Film",
        year: "2025",
        client: "BGMI",
        youtubeId: "KpPYyVl4Ht8",
        start: 21,
        image: "https://i.ytimg.com/vi/KpPYyVl4Ht8/maxresdefault.jpg",
        externalUrl: "https://youtu.be/KpPYyVl4Ht8",
        duration: 4500
    },
    {
        id: "bgmi-energy-drink",
        title: "BGMI Energy",
        subtitle: "Parody energy drink film",
        category: "Brand Film",
        year: "2025",
        client: "BGMI",
        youtubeId: "0_nMPk66hAA",
        start: 16,
        image: "https://i.ytimg.com/vi/0_nMPk66hAA/maxresdefault.jpg",
        externalUrl: "https://youtu.be/0_nMPk66hAA",
        duration: 4700
    },
    {
        id: "treet-wood",
        title: "Treet",
        subtitle: "Texture-driven product film",
        category: "Brand Film",
        year: "2025",
        client: "Treet",
        youtubeId: "GBZeqcGFdQo",
        start: 11,
        image: "https://i.ytimg.com/vi/GBZeqcGFdQo/maxresdefault.jpg",
        externalUrl: "https://youtu.be/GBZeqcGFdQo",
        duration: 5300
    },
    {
        id: "untitled-commercial-01",
        title: "Untitled 01",
        subtitle: "Brand film — in the house",
        category: "Brand Film",
        year: "2025",
        client: "Mad House",
        youtubeId: "JIrOcATg3jQ",
        start: 25,
        image: "https://i.ytimg.com/vi/JIrOcATg3jQ/maxresdefault.jpg",
        externalUrl: "https://youtu.be/JIrOcATg3jQ",
        duration: 4900
    },
    {
        id: "untitled-commercial-02",
        title: "Untitled 02",
        subtitle: "Brand film — in the house",
        category: "Brand Film",
        year: "2025",
        client: "Mad House",
        youtubeId: "LXRNVDaYdjU",
        start: 19,
        image: "https://i.ytimg.com/vi/LXRNVDaYdjU/maxresdefault.jpg",
        externalUrl: "https://youtu.be/LXRNVDaYdjU",
        duration: 5100
    },
    {
        id: "mv-squid-game",
        title: "Squid Game",
        subtitle: "High-contrast music film",
        category: "Music Video",
        year: "2025",
        client: "Squid Game",
        youtubeId: "IsQOfF7Hft0",
        start: 38,
        image: "https://i.ytimg.com/vi/IsQOfF7Hft0/maxresdefault.jpg",
        externalUrl: "https://youtu.be/IsQOfF7Hft0",
        duration: 4800
    },
    // mv-tdt (oGsYQWHK0lo) intentionally omitted — age-restricted, can't embed.
    {
        id: "mv-ray",
        title: "Ray",
        subtitle: "Moody, intimate, cinematic",
        category: "Music Video",
        year: "2025",
        client: "Ray",
        youtubeId: "nTfQKC6QaSY",
        start: 41,
        image: "https://i.ytimg.com/vi/nTfQKC6QaSY/maxresdefault.jpg",
        externalUrl: "https://youtu.be/nTfQKC6QaSY",
        duration: 5400
    },
    {
        id: "mv-garden-of-dreams",
        title: "Garden of Dreams",
        subtitle: "Pastel surreal dreamscape",
        category: "Music Video",
        year: "2025",
        client: "Garden of Dreams",
        youtubeId: "zjptCc6Bg_4",
        start: 33,
        image: "https://i.ytimg.com/vi/zjptCc6Bg_4/maxresdefault.jpg",
        externalUrl: "https://youtu.be/zjptCc6Bg_4",
        duration: 4700
    },
    {
        id: "mv-shanka-tribe-umoja",
        title: "Shanka Tribe — UMOJA",
        subtitle: "Visual EP. Afro-Konkan",
        category: "Music Video",
        year: "2025",
        client: "Shanka Tribe",
        youtubeId: "8uGDa_I6LZo",
        start: 47,
        image: "https://i.ytimg.com/vi/8uGDa_I6LZo/maxresdefault.jpg",
        externalUrl: "https://youtu.be/8uGDa_I6LZo",
        duration: 5200
    },
    {
        id: "mv-brodha-v",
        title: "Brodha V",
        subtitle: "Hip-hop × cinema",
        category: "Music Video",
        year: "2025",
        client: "Brodha V",
        youtubeId: "4P4Iee1WaAc",
        start: 26,
        image: "https://i.ytimg.com/vi/4P4Iee1WaAc/maxresdefault.jpg",
        externalUrl: "https://youtu.be/4P4Iee1WaAc",
        duration: 4900
    },
    {
        id: "mv-ring-a-rose",
        title: "Ring a Rose",
        subtitle: "Dark fairytale. Score-driven",
        category: "Music Video",
        year: "2025",
        client: "Ring a Rose",
        youtubeId: "_1PVlUqsxho",
        start: 35,
        image: "https://i.ytimg.com/vi/_1PVlUqsxho/maxresdefault.jpg",
        externalUrl: "https://youtu.be/_1PVlUqsxho",
        duration: 5100
    },
    {
        id: "mv-kamaal-hai",
        title: "Kamaal Hai",
        subtitle: "Bright, euphoric pop visual",
        category: "Music Video",
        year: "2025",
        client: "Kamaal Hai",
        youtubeId: "odXyDudFDdg",
        start: 24,
        image: "https://i.ytimg.com/vi/odXyDudFDdg/maxresdefault.jpg",
        externalUrl: "https://youtu.be/odXyDudFDdg",
        duration: 4600
    }
];

// Categories presented on the "Reel by Reel" page.
// Buttons render in this order; BRAND FILMS opens by default.
export const WORK_CATEGORIES = [
    { id: "brand-films", label: "Brand Films" },
    { id: "music-culture", label: "Music & Culture" },
    { id: "cgi-product-worlds", label: "CGI & Product Worlds" },
    { id: "short-films", label: "Short Films" }
];

// Canonical reel list.
// - `platform`     → "youtube" | "instagram" (controls thumbnail + embed strategy)
// - `youtubeId`    → 11-char video ID (youtube only)
// - `instaId`      → Instagram reel shortcode (instagram only)
// - `externalUrl`  → cleaned share URL, opens on click (new tab)
// - `title`        → short client-facing project name
// - `subtitle`     → one-line premium descriptor
// - `client`       → brand / artist credited on the card meta row
// - `category`     → matches WORK_CATEGORIES.id
// - `poster`       → optional. Local poster image path, e.g. "/assets/reels/kfc-poster.jpg".
//                    Used for thumbnail + hero cover. Overrides the YouTube auto-thumb.
//                    Required for Instagram items if you want a real photo (else stylised
//                    fallback poster is shown).
// - `preview`      → optional. Local muted preview clip path, e.g. "/assets/reels/kfc-preview.mp4".
//                    Played on thumbnail hover AND inside the hero window when clicked.
//                    Keep clips ≤ 5s and ≤ 2 MB. WebM preferred, MP4 also fine.
//                    See /app/frontend/public/assets/reels/README.md for the import workflow.
export const WORK_REELS = [
    // -------- BRAND FILMS (in exact order) --------
    {
        id: "bgmi-royal-enfield",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "5I86-Av-KoI",
        externalUrl: "https://youtu.be/5I86-Av-KoI",
        title: "BGMI × RE",
        subtitle: "Cinematic brand crossover film.",
        client: "BGMI × Royal Enfield"
    },
    {
        id: "bgmi-hipster",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "2bDL4m6x7KU",
        externalUrl: "https://youtu.be/2bDL4m6x7KU",
        title: "BGMI Hipster",
        subtitle: "Street-culture gaming cutdown.",
        client: "BGMI"
    },
    {
        id: "himalaya-baby-care",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "XjFUpYPVBl8",
        externalUrl: "https://youtu.be/XjFUpYPVBl8",
        title: "Himalaya Baby Care",
        subtitle: "Warm, tender, quietly cinematic.",
        client: "Himalaya"
    },
    {
        id: "bgmi-energy-drink",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "0_nMPk66hAA",
        externalUrl: "https://youtu.be/0_nMPk66hAA",
        title: "BGMI Energy Drink",
        subtitle: "Parody energy drink film.",
        client: "BGMI"
    },
    {
        id: "bgmi-helmet",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "KpPYyVl4Ht8",
        externalUrl: "https://youtu.be/KpPYyVl4Ht8",
        title: "BGMI Helmet",
        subtitle: "Parody helmet spot.",
        client: "BGMI"
    },
    {
        id: "treet-wood",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "GBZeqcGFdQo",
        externalUrl: "https://youtu.be/GBZeqcGFdQo",
        title: "Treet Wood",
        subtitle: "Texture-driven product film.",
        client: "Treet"
    },
    {
        id: "cred-tr-nation",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "SQtZo4SvBzw",
        externalUrl: "https://youtu.be/SQtZo4SvBzw",
        title: "CRED — TR Nation",
        subtitle: "Pop-culture commercial. Larger than life.",
        client: "CRED"
    },
    {
        id: "crocs-rashmika",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "SS6nqU6IioM",
        externalUrl: "https://youtu.be/SS6nqU6IioM",
        title: "Crocs — Rashmika",
        subtitle: "Fashion film. Personal. Playful.",
        client: "Crocs"
    },
    {
        id: "untitled-commercial-01",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "JIrOcATg3jQ",
        externalUrl: "https://youtu.be/JIrOcATg3jQ",
        title: "Untitled Commercial 01",
        subtitle: "Brand film — in the house.",
        client: "Mad House"
    },
    {
        id: "untitled-commercial-02",
        category: "brand-films",
        platform: "youtube",
        youtubeId: "LXRNVDaYdjU",
        externalUrl: "https://youtu.be/LXRNVDaYdjU",
        title: "Untitled Commercial 02",
        subtitle: "Brand film — in the house.",
        client: "Mad House"
    },

    // -------- MUSIC & CULTURE (in exact order) --------
    {
        id: "mv-squid-game",
        category: "music-culture",
        platform: "youtube",
        youtubeId: "IsQOfF7Hft0",
        externalUrl: "https://youtu.be/IsQOfF7Hft0",
        title: "Squid Game",
        subtitle: "High-contrast music film.",
        client: "Squid Game"
    },
    {
        id: "mv-tdt",
        category: "music-culture",
        platform: "youtube",
        youtubeId: "oGsYQWHK0lo",
        externalUrl: "https://youtu.be/oGsYQWHK0lo",
        title: "TDT",
        subtitle: "Frenetic, textured, loud.",
        client: "TDT"
    },
    {
        id: "mv-ray",
        category: "music-culture",
        platform: "youtube",
        youtubeId: "nTfQKC6QaSY",
        externalUrl: "https://youtu.be/nTfQKC6QaSY",
        title: "Ray",
        subtitle: "Moody, intimate, cinematic.",
        client: "Ray"
    },
    {
        id: "mv-garden-of-dreams",
        category: "music-culture",
        platform: "youtube",
        youtubeId: "zjptCc6Bg_4",
        externalUrl: "https://youtu.be/zjptCc6Bg_4",
        title: "Garden of Dreams",
        subtitle: "Pastel surreal dreamscape.",
        client: "Garden of Dreams"
    },
    {
        id: "mv-shanka-tribe-umoja",
        category: "music-culture",
        platform: "youtube",
        youtubeId: "8uGDa_I6LZo",
        externalUrl: "https://youtu.be/8uGDa_I6LZo",
        title: "Shanka Tribe — UMOJA",
        subtitle: "Visual EP. Afro-Konkan.",
        client: "Shanka Tribe"
    },
    {
        id: "mv-brodha-v",
        category: "music-culture",
        platform: "youtube",
        youtubeId: "4P4Iee1WaAc",
        externalUrl: "https://youtu.be/4P4Iee1WaAc",
        title: "Brodha V",
        subtitle: "Hip-hop × cinema.",
        client: "Brodha V"
    },
    {
        id: "mv-ring-a-rose",
        category: "music-culture",
        platform: "youtube",
        youtubeId: "_1PVlUqsxho",
        externalUrl: "https://youtu.be/_1PVlUqsxho",
        title: "Ring a Rose",
        subtitle: "Dark fairytale. Score-driven.",
        client: "Ring a Rose"
    },
    {
        id: "mv-kamaal-hai",
        category: "music-culture",
        platform: "youtube",
        youtubeId: "odXyDudFDdg",
        externalUrl: "https://youtu.be/odXyDudFDdg",
        title: "Kamaal Hai",
        subtitle: "Bright, euphoric pop visual.",
        client: "Kamaal Hai"
    }
];

export const SERVICES = [
    { id: "01", title: "VFX & Compositing", desc: "Invisible integrations, set extensions, beauty, cleanup." },
    { id: "02", title: "CGI / 3D", desc: "Photoreal product, environment and FX for cinema and commercials." },
    { id: "03", title: "Color Grading", desc: "Look development, conform & final grade in DaVinci Resolve." },
    { id: "04", title: "Motion Design", desc: "Design-driven animation, titles, graphics for brands." },
    { id: "05", title: "Cleanup & Beauty", desc: "Retouching, rig removal, skin, shape, detail work." },
    { id: "06", title: "AI Visual Production", desc: "Generative pipelines stitched into cinematic workflows." },
    { id: "07", title: "Final Delivery", desc: "QC, mastering, spec delivery for broadcast, cinema & digital." }
];

export const NAV_LINKS = [
    { label: "Work", href: "#work", type: "anchor" },
    { label: "About", href: "#about", type: "anchor" },
    { label: "Contact", href: "#contact", type: "anchor" }
];

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_ed6c79c9-0545-4c0e-b197-76f179257e91/artifacts/ngrkmddy_MAD%20HOUSE%20LOGO%201%20TRANSPARENT%402x.png";
